import styled from 'styled-components';
import {
  py, m, p, pr, px, mx
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';

export const StyledCardWrapper = styled.div`
  ${py(1)};
  ${m(2)};
  border-radius: 12px;
  ${theme.shadows.mediumStrong}
`;

export const StyledImageWrapper = styled.div`
  height: 100%;
  ${p(2)};
  img {
    width: 100%;
    border: 1px solid transparent;
    border-radius: 8px;
    max-width: -webkit-fill-available;
  }
`;

export const StyledRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${p(3)};
`;

export const StyledFlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-item: center;
  ${mx(3)};
  ${p(2)}
  ${breakpoint('mobile', 'desktop')`
  ${py(1)}
  `}
`;
export const StyledHeadline = styled.div`
  color: ${theme.colors.navyGray};
  font-weight: bold;
  font-size: 22px;

  width: 100%;
  ${breakpoint('mobile', 'desktop')`
  line-height:1.5rem;
  font-size: 16px;
  `}
`;

export const StyledLocationWrapper = styled.div`
  color: ${theme.colors.mediumGray};
  font-weight: bold;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  svg {
    height: 20px;
    width: 20px;
    ${pr(1)};
  }
`;

export const StyledPlacesList = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.7rem;
  font-size: 20px;
  ${px(2)};
  ${breakpoint('mobile', 'desktop')`
    font-size: 16px;
  `};
`;

export const StyledDescription = styled.div`
  color: ${theme.colors.navyGray};
  ${py(2)};
`;
